import { PlaneTakeoff } from '@orgus/ui/icons';
import type { SettingsSection } from '../registry.ts';
import { LaunchSettingsView } from '../../policy/LaunchSettingsView.tsx';

const section: SettingsSection = {
  id: 'launch',
  title: 'Launch settings',
  description: 'Model, permission mode and secrets for sessions Orgus starts.',
  order: 20,
  group: 'agents',
  keywords: ['permission mode', 'permissions', 'model', 'claude code', 'launch', 'start', 'defaults', 'idle', 'close idle sessions'],
  icon: PlaneTakeoff,
  Component: LaunchSettingsView,
};
export default section;
